var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "my-panel" }, [
    _c("div", { staticClass: "level my-panel-heading" }, [
      _c(
        "div",
        { staticClass: "level-left" },
        [
          _c("h3", {
            class: ["title", _vm.size],
            domProps: { textContent: _vm._s(_vm.heading) },
          }),
          _vm._t("subtitle"),
        ],
        2
      ),
      _c("div", { staticClass: "level-right" }, [_vm._t("heading")], 2),
    ]),
    _c("div", { staticClass: "my-panel-body" }, [_vm._t("default")], 2),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }